import { render, staticRenderFns } from "./DimeTag.vue?vue&type=template&id=2db48bec&scoped=true"
import script from "./DimeTag.vue?vue&type=script&lang=js"
export * from "./DimeTag.vue?vue&type=script&lang=js"
import style0 from "./DimeTag.vue?vue&type=style&index=0&id=2db48bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db48bec",
  null
  
)

export default component.exports